import { confirmAmazonPayment, initializeAmazonPayment } from 'src/common/facades/eagle/checkout';
import logger from 'src/logger';
import { getCookies } from 'src/client/js/facades/eagle/helpers/cookies';

const payWithAmazon = async ({
  setIsSubmitting,
  amazonOrderRef,
  failureUrl,
  successRedirectUrl,
  amazonMerchantId,
  scaEnabled,
  nativeAmazonClient,
  marketingOptIn,
  sendErrorMessage,
}) => {
  // First of all, set isSubmitting to true, so that everyone knows that submission has started. Display spinners, disable buttons, etc.
  setIsSubmitting(true);
  const initializationFunc = async () => {
    try {
      const res = await initializeAmazonPayment(amazonOrderRef,
        failureUrl,
        successRedirectUrl,
        marketingOptIn,
        getCookies()
      );
      if (res && res.orderComplete) {
        window.location = successRedirectUrl;
        return false; // no need to continue flow.
      }
    } catch (err) {
      logger.warn(err, 'Cannot process amazon order');
      sendErrorMessage(error => error.payment.order);
      // Setting the loader to false triggers a state update, which re-renders the widget.
      // Thanks to the re-render, Amazon's widgets will reload and show any user-related errors.
      setIsSubmitting(false);
      return false;
    }
    return true;
  };

  if (scaEnabled) {
    return nativeAmazonClient.initConfirmationFlow(amazonMerchantId, amazonOrderRef, async (confirmationFlow) => {
      const initSuccess = await initializationFunc();
      // ^^ This should initialize the amazon payment in the backend, and call the confirm_order_reference method (https://developer.amazon.com/docs/eu/amazon-pay-onetime/sca-upgrade.html)

      if (!initSuccess) {
        return;
      }

      confirmationFlow.popUpWindow = true;
      confirmationFlow.success();
      // After success() is called, this should take customer to the SCA flow. When it's done, the customer will be redirected to the success_url provided to Amazon on the previous step by the backend.
      // This success_url should point to a new eagle endpoint which should finalize the payment, and redirect the user to confirmation page.
    });
  }

  const initSuccess = await initializationFunc();

  if (!initSuccess) {
    return;
  }

  try {
    await confirmAmazonPayment(amazonOrderRef, failureUrl, successRedirectUrl, getCookies());
    window.location = successRedirectUrl;
  } catch (err) {
    logger.warn(err, 'Error completing Amazon Order!');
    sendErrorMessage(error => error.payment.order);
    setIsSubmitting(false);
    return false;
  }
};

export default payWithAmazon;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/Amazon/helpers.js